export default class Locale_WorkPackageImportDialog {
	AddWorkPackages: string = "Add request templates";
}